import axios from 'axios';
import AxiosMockAdapter from 'axios-mock-adapter';
import { serializeParamsInterceptor, errorHandlerInterceptor } from './interceptors';

const API_HEADERS = {};
const API_CONFIG = {};
const API_TOKEN_STORAGE = sessionStorage;

// SET API CONFIGURATION
API_HEADERS['X-Requested-With'] = 'XMLHttpRequest';

API_CONFIG.baseURL = process.env.VUE_APP_API_URL;
API_CONFIG.headers = API_HEADERS;
API_CONFIG.timeout = 30000;
API_CONFIG.withCredentials = true;

const API = axios.create(API_CONFIG);

if (process.env.VUE_APP_MOCK) {
  const mocks = require('@/config/mocks');
  const mock = new AxiosMockAdapter(API, { delayResponse: 2000 });
  mocks.responses.forEach((responses) => {
    const [method, url, status, response] = responses.shift();
    const data = { ...response };
    mock[method](url).reply(status, { data });
  });
  mock.onAny().passThrough();
}

let requestInterceptor = API.interceptors.request.use(
  serializeParamsInterceptor,
  errorHandlerInterceptor,
);
let responseInterceptor = API.interceptors.response.use(config => config, errorHandlerInterceptor);

API.addResponseInterceptor = () => {
  API.interceptors.request.use(requestInterceptor);
};
API.removeResponseInterceptor = () => {
  API.interceptors.request.eject(requestInterceptor);
};
API.addResponseInterceptor = () => {
  if (API.interceptors.response.handlers.length === 1) {
    responseInterceptor = API.interceptors.response.use(config => config, errorHandlerInterceptor);
  }
};
API.removeResponseInterceptor = () => {
  API.interceptors.response.eject(responseInterceptor);
};

// SET AUTH CONFIGURATION
const AUTHORIZATION_OPTIONS = {
  endpoints: {
    login: '/authorization/loginToPlatform',
    logout: '/authorization/logoutFromPlatform',
    session: '/authorization/checkIfUserSessionExist',
    registration: '/authorization/registrationToPlatform',
  },
};

// EXPORT CONFIGURATION
export { API, API_TOKEN_STORAGE, AUTHORIZATION_OPTIONS };
